import { render, staticRenderFns } from "./S-13.vue?vue&type=template&id=e4f65674&scoped=true&"
import script from "./S-13.vue?vue&type=script&lang=js&"
export * from "./S-13.vue?vue&type=script&lang=js&"
import style0 from "./S-13.vue?vue&type=style&index=0&id=e4f65674&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4f65674",
  null
  
)

export default component.exports